module.exports = __webpack_public_path__ + "img/A002.1f3cd089.png";